import {
  NumberInput as RawNumberInput,
  NumberInputProps as RawNumberInputProps,
} from '@mantine/core';
import { useFormState } from 'components/elements/form';
import React from 'react';
import { useController } from 'react-hook-form';

export interface NumberInputProps extends Omit<RawNumberInputProps, 'type'> {
  type: 'number';
  name: string;
  isCurrency?: boolean;
}

export default function NumberInput(props: NumberInputProps) {
  const {
    onChange,
    disabled,
    readOnly,
    name,
    type,
    error,
    isCurrency = true,
    thousandSeparator,
    placeholder,
    ...rest
  } = props;
  const formState = useFormState();
  const { field, fieldState } = useController({
    name,
  });

  const _disabled = formState.editable === false || disabled || readOnly;
  const _error = fieldState.error?.message || error;

  const _placeholder = React.useMemo(() => {
    if (_disabled) return undefined;
    return placeholder;
  }, [_disabled, placeholder]);

  const withAsterisk = React.useMemo(() => {
    if (_disabled) return false;
    if (rest.required || rest.withAsterisk) return true;
  }, [_disabled, rest.required, rest.withAsterisk]);

  return (
    <RawNumberInput
      {...rest}
      {...field}
      disabled={_disabled}
      placeholder={_placeholder}
      error={_error}
      value={field.value}
      onChange={(value) => {
        field.onChange(value);
        onChange?.(value);
      }}
      styles={{
        input: {
          textAlign: isCurrency ? 'right' : 'left',
        },
      }}
      thousandSeparator={thousandSeparator ?? (isCurrency ? ',' : undefined)}
      withAsterisk={withAsterisk}
    />
  );
}
